var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mb-2" }, [
      _c(
        "label",
        {
          staticClass: "form-label",
          attrs: { for: "exampleFormControlInput1" },
        },
        [_vm._v("Internal Name")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.name,
            expression: "name",
          },
        ],
        staticClass: "form-control has-validation",
        attrs: {
          type: "text",
          id: "internal_name",
          placeholder: "Welcome Email - Free members",
          required: "",
        },
        domProps: { value: _vm.name },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.name = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm.errors && _vm.errors.name
        ? _c(
            "small",
            {
              staticClass: "form-text text-danger",
              attrs: { id: "error_name" },
            },
            [_vm._v("* " + _vm._s(_vm.errors.name[0]))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-check mb-1" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.email_enabled,
            expression: "email_enabled",
          },
        ],
        staticClass: "form-check-input",
        attrs: { type: "checkbox", id: "check-enabled", required: "" },
        domProps: {
          checked: Array.isArray(_vm.email_enabled)
            ? _vm._i(_vm.email_enabled, null) > -1
            : _vm.email_enabled,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.email_enabled,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.email_enabled = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.email_enabled = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.email_enabled = $$c
            }
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "form-check-label", attrs: { for: "flexCheckDefault" } },
        [_vm._v("\n            Enable this email\n        ")]
      ),
    ]),
    _vm._v(" "),
    _vm.errors && _vm.errors.enabled
      ? _c(
          "small",
          { staticClass: "form-text text-danger", attrs: { id: "error_name" } },
          [_vm._v("* " + _vm._s(_vm.errors.enabled[0]))]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mb-2" }, [
      _c(
        "label",
        {
          staticClass: "form-label",
          attrs: { for: "exampleFormControlInput1" },
        },
        [_vm._v("Delay Mins")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.delay,
            expression: "delay",
          },
        ],
        staticClass: "form-control",
        attrs: {
          type: "number",
          id: "delay_mins",
          min: "0",
          max: "10080",
          required: "",
        },
        domProps: { value: _vm.delay },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.delay = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "small",
        { staticClass: "form-text text-muted", attrs: { id: "delayHelp" } },
        [
          _vm._v(
            "The email will be sent X minutes after the trigger occurred. 0 will send immediately"
          ),
        ]
      ),
      _vm._v(" "),
      _vm.errors && _vm.errors.delay
        ? _c(
            "small",
            {
              staticClass: "form-text text-danger",
              attrs: { id: "error_name" },
            },
            [_vm._v("* " + _vm._s(_vm.errors.delay[0]))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-2" }, [
      _c("label", { attrs: { for: "filter_option" } }, [
        _vm._v("Email Template"),
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.email_template_id,
              expression: "email_template_id",
            },
          ],
          staticClass: "custom-select",
          attrs: { id: "template_options", required: "" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.email_template_id = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        _vm._l(_vm.available_email_templates, function (template) {
          return _c(
            "option",
            { key: template.id, domProps: { value: template.id } },
            [_vm._v(_vm._s(template.name))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "small",
        { staticClass: "form-text text-muted", attrs: { id: "filtersHelp" } },
        [_vm._v("The email colour theme.")]
      ),
      _vm._v(" "),
      _vm.errors && _vm.errors.email_template_id
        ? _c(
            "small",
            {
              staticClass: "form-text text-danger",
              attrs: { id: "error_name" },
            },
            [_vm._v("* " + _vm._s(_vm.errors.email_template_id[0]))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-2" }, [
      _c("label", { attrs: { for: "trigger_select" } }, [_vm._v("Trigger")]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.trigger_id,
              expression: "trigger_id",
            },
          ],
          staticClass: "custom-select",
          attrs: { id: "trigger_select", required: "" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.trigger_id = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        _vm._l(_vm.available_trigger_options, function (trigger) {
          return _c(
            "option",
            { key: trigger.id, domProps: { value: trigger.id } },
            [_vm._v(_vm._s(trigger.name))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "small",
        { staticClass: "form-text text-muted", attrs: { id: "filtersHelp" } },
        [
          _vm._v(
            "When this action occurs it triggers an email to the user that performed the action."
          ),
        ]
      ),
      _vm._v(" "),
      _vm.errors && _vm.errors.trigger_id
        ? _c(
            "small",
            {
              staticClass: "form-text text-danger",
              attrs: { id: "error_trigger" },
            },
            [_vm._v("* " + _vm._s(_vm.errors.trigger_id[0]))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-2" }, [
      _c("label", { attrs: { for: "filter_option" } }, [
        _vm._v("Audience Filters"),
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.filter_id,
              expression: "filter_id",
            },
          ],
          staticClass: "custom-select",
          attrs: { id: "filter_option", required: "" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.filter_id = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        _vm._l(_vm.available_filter_options, function (filter) {
          return _c(
            "option",
            { key: filter.id, domProps: { value: filter.id } },
            [_vm._v(_vm._s(filter.name))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "small",
        { staticClass: "form-text text-muted", attrs: { id: "filtersHelp" } },
        [_vm._v("Will send to the user if they match the filter criteria")]
      ),
      _vm._v(" "),
      _vm.errors && _vm.errors.filter_id
        ? _c(
            "small",
            {
              staticClass: "form-text text-danger",
              attrs: { id: "error_name" },
            },
            [_vm._v("* " + _vm._s(_vm.errors.filter_id[0]))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "email_subject" } },
        [_vm._v("Email Subject")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.email_subject,
            expression: "email_subject",
          },
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          id: "email_subject",
          placeholder: "Welcome to the community",
          required: "",
        },
        domProps: { value: _vm.email_subject },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.email_subject = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm.errors && _vm.errors.subject
        ? _c(
            "small",
            {
              staticClass: "form-text text-danger",
              attrs: { id: "error_name" },
            },
            [_vm._v("* " + _vm._s(_vm.errors.subject[0]))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-05" }, [
      _c(
        "label",
        { staticClass: "required mt-1", attrs: { for: "email_content" } },
        [_vm._v("Email Content")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card my-0" },
        [
          _c("editor", {
            attrs: {
              "api-key": "no-api-key",
              init: {
                skin: "trybz-member",
                skin_url: "/plugins/tiny-mce-skin/ui/trybz-member",
                content_css:
                  "/plugins/tiny-mce-skin/content/trybz-member/content.min.css",
                external_plugins: {
                  customtags:
                    "/plugins/tiny-mce-plugins/customtags/plugin.min.js",
                  loadingbar:
                    "/plugins/tiny-mce-plugins/loadingbar/plugin.min.js",
                },
                // valid_elements : "p,br,b,i,b/strong,i/em,a[href|target=_blank],li[a|b|i|u|ol|ul],ol[li],ul[li],hr",
                plugins:
                  "table lists link image media code wordcount customtags loadingbar",
                toolbar:
                  "undo redo | styles fontsize hr | alignleft aligncenter alignright alignjustify | forecolor backcolor | bullist numlist | removeformat | link table | a11ycheck code",
                toolbar_mode: "wrap",
                image_title: true,
                link_context_toolbar: true,
                link_assume_external_targets: "https",
                link_target_list: false,
                link_title: false,
                branding: false,
                elementpath: false,
                menubar: false,
                file_picker_types: "",
                height: 500,
                content_style:
                  "body { font-family: Montserrat, Helvetica, Arial, serif; font-size: 0.86rem; font-weight: 400; line-height: 1.45; color: #1d2124; }",
                relative_urls: false,
                remove_script_host: false,
              },
            },
            model: {
              value: _vm.email_content,
              callback: function ($$v) {
                _vm.email_content = $$v
              },
              expression: "email_content",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "small",
        { staticClass: "form-text text-muted", attrs: { id: "filtersHelp" } },
        [_vm._v("Available tags [first_name], [last_name], [email]")]
      ),
      _vm._v(" "),
      _vm.errors && _vm.errors.content
        ? _c(
            "small",
            {
              staticClass: "form-text text-danger",
              attrs: { id: "error_name" },
            },
            [_vm._v("* " + _vm._s(_vm.errors.content[0]))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("small", { staticClass: "form-text", attrs: { id: "error_name" } }, [
        _vm._v(
          "*If you are using modules and all modules have no content, the email wont send."
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-row-reverse" }, [
      _c(
        "div",
        { staticClass: "d-grid gap-2 d-md-flex justify-content-md-end" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect waves-light",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.saveAndSendTest.apply(null, arguments)
                },
              },
            },
            [_vm._v("Save & Send a copy to yourself")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-grid gap-2 d-md-flex justify-content-md-end" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect waves-light mr-1",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [_vm._v("Save")]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }